<div
  *ngIf="(repository.nomenclature$ | async)?.attributes?.isExpress && !(isUrgent$ | async)"
  class="typography grey-900"
  style="margin-top: 12px"
>
  <span class="icon icon-1.5x icon-cito"></span>
  <span class="ml-8">Срок выполнения:</span>
  <!-- TODO от скольки дней -->
  <span class="ml-8 tag bg-violet-accent">от 1 дня</span>
</div>

<ng-container
  *ngIf="(isUrgent$ | async)"
  [ngTemplateOutlet]="item"
  [ngTemplateOutletContext]="{
    iconName: 'cito',
    description: 'Срочный анализ'
  }"
></ng-container>

<ng-template #item let-iconName="iconName" let-description="description">
  <div class="typography grey-900" style="margin-top: 12px">
    <span class="icon icon-1.5x icon-{{ iconName }}"></span>
    <span class="ml-8">{{ description }} </span>
  </div>
</ng-template>
